import { h, Component } from 'preact';

import s from 'components/shared/dynamicPageLoader/loader.sss';

export default class Loader extends Component {
	render() {
		return (
			<div class={s.loader}>Loading...</div>
		);
	}
}
